<script>
export default {
  name: "ElTagColorGps",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    const col = context.props.column;
    const val = context.props.row[col];
    const rowValue = context.props.row;
    let Contrato = rowValue.color;
    let reason = rowValue.reason;
    if (reason == "Contrato Abierto") {
      return createElement(
        "span",
        {
          class: "el-tag  el-tag--success el-tag--plain"
        },
        val
      );
    } else if (reason != "Contrato Abierto") {
      return createElement(
        "span",
        {
          class: "el-tag  el-tag--danger el-tag--plain"
        },
        val
      );
    } else if (Contrato) {
      return createElement(
        "span",
        {
          class: `el-tag  el-tag--${Contrato} el-tag--plain`
        },
        val
      );
    } else {
      return createElement(
        "span",
        {
          class: "el-tag  el-tag--success el-tag--plain"
        },
        val
      );
    }
  }
};
</script>
